import { Component } from '@angular/core';

import { AnswerTypeComponent } from '../answer-type.component';

@Component({
    selector: 'answer-textarea',
    templateUrl: './answer-textarea.component.html',
    standalone: false
})
export class AnswerTextareaComponent extends AnswerTypeComponent {

}
